/**
 * @generated SignedSource<<d566683f6c672f66a99d2e2ddf23b02f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TransferAppDestinationCancelMutation$variables = {
  appId: string;
};
export type TransferAppDestinationCancelMutation$data = {
  readonly cancelAppTransferRequest: {
    readonly transferRequestDestination: {
      readonly __typename: string;
    } | null | undefined;
  };
};
export type TransferAppDestinationCancelMutation = {
  response: TransferAppDestinationCancelMutation$data;
  variables: TransferAppDestinationCancelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "appId",
    "variableName": "appId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TransferAppDestinationCancelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "cancelAppTransferRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "transferRequestDestination",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "TransferAppDestinationCancelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "cancelAppTransferRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "transferRequestDestination",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*:: as any*/)
                ],
                "type": "Organization",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a177aee622826b1921ff55096a380bf1",
    "id": null,
    "metadata": {},
    "name": "TransferAppDestinationCancelMutation",
    "operationKind": "mutation",
    "text": "mutation TransferAppDestinationCancelMutation(\n  $appId: ID!\n) {\n  cancelAppTransferRequest(appId: $appId) {\n    transferRequestDestination {\n      __typename\n      ... on Organization {\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ea4cbfce33608521bb3856e51e2f96f";

export default node;
